module.exports = __webpack_public_path__ + "static/media/newLinkedin.8b641e61.svg";